import { fieldIsPaidInReport } from "@/constant";
import timetableReportStatusEnum from "@/constant/timetableReportStatusEnum";
import { conferenceTypesEnum } from "@modals/Timetable/AddLessonOrMeeting/components/ConferenceType/conferenceTypesEnum";

const HIDDEN_LINK_STATUSES = [
  timetableReportStatusEnum.canceledStudent,
  timetableReportStatusEnum.canceledSeminarian,
  timetableReportStatusEnum.paidCancellation,
  timetableReportStatusEnum.cancelledUnpaid,
];

export const shouldHideLinkToCanceledLesson = ({
  report,
  isEnabled,
  isTeacherSide,
}) => {
  if (String(isEnabled) !== '1' || !isTeacherSide) return false;

  return HIDDEN_LINK_STATUSES.includes(Number(report?.status));
};

export const shouldHideLinkToUnpaidLesson = ({
  report,
  isEnabled,
  isTeacherSide,
}) => {
  if (String(isEnabled) !== '1' || !isTeacherSide) return false;

  const isLessonPaid =
    report?.[fieldIsPaidInReport] === true ||
    Number(report?.[fieldIsPaidInReport]) === 1;

  return report?.conference_type === conferenceTypesEnum.private && !isLessonPaid;
};

export const shouldHideLessonLink = ({
  report,
  isEnabled,
  isTeacherSide,
}) => (
  shouldHideLinkToCanceledLesson({ report, isEnabled, isTeacherSide }) ||
  shouldHideLinkToUnpaidLesson({ report, isEnabled, isTeacherSide })
);
